import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  fullWidth?: boolean;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  fullWidth = false,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-full font-semibold transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-[#00E676] text-white hover:bg-[#00c865] hover:shadow-lg shadow-md focus:ring-[#00E676]',
    secondary: 'bg-[#064E3B] text-white hover:bg-[#022c22] hover:shadow-lg shadow-md focus:ring-[#064E3B]',
    outline: 'border-2 border-[#00E676] text-[#00E676] hover:bg-[#00E676] hover:text-white focus:ring-[#00E676]',
    ghost: 'text-gray-600 hover:text-[#00E676] hover:bg-green-50 focus:ring-gray-200'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className} ${isLoading ? 'opacity-80' : ''}`} disabled={disabled || isLoading} {...props} data-id="element-534">
      {isLoading && <Loader2 className="w-4 h-4 mr-2 animate-spin" data-id="element-535" />}
      {children}
    </button>;
}